import * as angular from 'angular';

import { common } from '../common';
import { ngxInviteServiceModule } from '@go-modules/services/invite';

export const inviteModelModule = angular.module('go.models.invite', [
	common,
	ngxInviteServiceModule
])
	.name;
